module.exports = __webpack_public_path__ + "img/gradient.47b35d75.png";